import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool } from '../../../../../helpers/custom-prop-types';
const SeminarOneSubTitle = (props) => {
    const { isSelf } = props;
    if (isSelf) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'professional_seminar_one_sub_title' }, { children: _jsx("div", Object.assign({ className: 'title_other' }, { children: _jsx("div", Object.assign({ className: 'other_text text-liststyle' }, { children: "\u4ED6\u306E\u4EBA\u304C\u4F5C\u6210\u3057\u305F\u30BB\u30DF\u30CA\u30FC\u306E\u5185\u5BB9\u306F\u7DE8\u96C6\u3067\u304D\u307E\u305B\u3093" })) })) })));
};
SeminarOneSubTitle.propTypes = {
    isSelf: propBool().isRequired,
};
export default SeminarOneSubTitle;
